import React from 'react';
import { Box, Container, Paper, Typography, useTheme } from '@mui/material';
import { AccountBalance } from '@mui/icons-material';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        overflowY: 'auto',
      }}
    >
      <Container component="main" maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 4,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              p: 2,
              mb: 4,
              backgroundColor: 'transparent',
            }}
          >
            <AccountBalance sx={{ fontSize: 48, color: 'white' }} />
            <Typography
              variant="h3"
              component="h1"
              sx={{
                color: 'white',
                fontWeight: 700,
                letterSpacing: '-0.02em',
              }}
            >
              FalaVipPay
            </Typography>
          </Paper>

          <Typography
            variant="h6"
            sx={{
              color: 'white',
              opacity: 0.9,
              mb: 4,
              textAlign: 'center',
            }}
          >
            Sistema de Gestão Financeira Integrado com Sicoob
          </Typography>
        </Box>
      </Container>

      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Container maxWidth="sm" sx={{ width: '100%' }}>
          {children}
        </Container>
      </Box>

      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="body2" color="white" align="center">
            {'© '}
            {new Date().getFullYear()}
            {' FalaVipPay. Todos os direitos reservados.'}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default AuthLayout;